import React from "react";
import { Div, Image, Text } from "atomize";
import AnimateLink from "../common/AnimateLink";

const ScheduleDemoFlag = ({ content }) => {
  return (
    <>
      <AnimateLink to={content.flagLink}>
        <Div
          pos="absolute"
          zIndex="5"
          bottom="20%"
          right="0"
          textColor="black"
          p={{ y: "13px", l: "1rem", r: "20px" }}
          bg="primary"
          rounded={{ l: "50px" }}
          d={{ xs: "none", md: "flex" }}
        >
          <Image src={content.flagImage} h="30px" w="30px" m={{ r: "11px" }} />

          <Text
            maxW="8rem"
            textSize="caption2"
            textWeight="bold"
            fontFamily="secondary"
            style={{ lineHeight: "16px" }}
          >
            {content.flagText}
            <Text
              textColor="black"
              textSize="caption2"
              textWeight="bold"
              fontFamily="secondary"
              style={{ lineHeight: "16px" }}
            >
              {content.flagLinkText}
            </Text>
          </Text>
        </Div>
      </AnimateLink>
    </>
  );
};

export default ScheduleDemoFlag;
